import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import { CheckCircle, Home } from 'lucide-react'
import { Button } from '@/components/ui/Button'

export default function SubmitSuccessPage() {
  return (
    <div className="bg-background flex min-h-screen items-center justify-center px-4 py-16">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="max-w-md space-y-6 text-center"
      >
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ type: 'spring', delay: 0.2 }}
          className="bg-success/10 border-success/20 mx-auto flex h-20 w-20 items-center justify-center rounded-full border"
        >
          <CheckCircle className="text-success h-10 w-10" />
        </motion.div>

        <div className="space-y-3">
          <h1 className="text-foreground font-display text-3xl font-bold md:text-4xl">Photo Submitted!</h1>
          <p className="text-foreground-muted text-lg">
            Your photo has been submitted for review. You'll receive an email once it's approved.
          </p>
        </div>

        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.4 }}>
          <Link to="/">
            <Button variant="secondary" size="lg">
              <Home className="h-5 w-5" />
              Back to Home
            </Button>
          </Link>
        </motion.div>
      </motion.div>
    </div>
  )
}
